var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgError404Image(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 384,
    height: 384,
    viewBox: "0 0 384 384",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1601_734",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 384,
    height: 384
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 192,
    cy: 192,
    r: 192,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1601_734)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M227.595 300.168C292.673 300.168 345.429 250.18 345.429 188.518C345.429 126.856 292.673 76.8687 227.595 76.8687C162.518 76.8687 109.762 126.856 109.762 188.518C109.762 250.18 162.518 300.168 227.595 300.168Z",
    fill: "url(#paint0_radial_1601_734)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.725 220.5C245.185 220.5 259.339 206.346 259.339 188.886C259.339 171.426 245.185 157.271 227.725 157.271C210.265 157.271 196.111 171.426 196.111 188.886C196.111 206.346 210.265 220.5 227.725 220.5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.074 174.798H282.136V218.912H285.074V174.798Z",
    fill: "#EEEEEE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.137 174.798V209.354H257.874L282.137 174.798Z",
    fill: "#EEEEEE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.232 167.447H186.556V220.382H190.232V167.447Z",
    fill: "#EEEEEE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.557 167.412V207.881H157.883L186.557 167.412Z",
    fill: "#EEEEEE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.528 216.768V328.467H-130.336V216.974C-117.221 216.974 -106.399 212.343 -104.733 206.351C-103.067 212.343 -92.2449 216.974 -79.1299 216.974C-66.7791 216.974 -56.4614 212.87 -53.9087 207.382C-51.356 212.87 -41.0383 216.974 -28.6876 216.974C-15.5726 216.974 -4.7504 212.343 -3.08427 206.351C-1.41815 212.343 9.40402 216.974 22.519 216.974C35.634 216.974 46.4562 212.343 48.1223 206.351C49.7884 212.343 60.6106 216.974 73.7256 216.974C86.8406 216.974 97.6628 212.343 99.3289 206.351C100.995 212.343 111.817 216.974 124.932 216.974C138.047 216.974 148.869 212.343 150.535 206.351C152.202 212.343 163.024 216.974 176.139 216.974C189.254 216.974 200.076 212.343 201.742 206.351C203.408 212.343 214.23 216.974 227.345 216.974C240.46 216.974 251.282 212.343 252.949 206.351C254.615 212.343 265.437 216.974 278.552 216.974C291.667 216.974 302.489 212.343 304.155 206.351C305.821 212.343 316.643 216.974 329.758 216.974C331.386 216.974 332.984 216.905 334.528 216.768Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.528 216.768V328.467H-130.336V216.974C-117.221 216.974 -106.399 212.343 -104.733 206.351C-103.067 212.343 -92.2449 216.974 -79.1299 216.974C-66.7791 216.974 -56.4614 212.87 -53.9087 207.382C-51.356 212.87 -41.0383 216.974 -28.6876 216.974C-15.5726 216.974 -4.7504 212.343 -3.08427 206.351C-1.41815 212.343 9.40402 216.974 22.519 216.974C35.634 216.974 46.4562 212.343 48.1223 206.351C49.7884 212.343 60.6106 216.974 73.7256 216.974C86.8406 216.974 97.6628 212.343 99.3289 206.351C100.995 212.343 111.817 216.974 124.932 216.974C138.047 216.974 148.869 212.343 150.535 206.351C152.202 212.343 163.024 216.974 176.139 216.974C189.254 216.974 200.076 212.343 201.742 206.351C203.408 212.343 214.23 216.974 227.345 216.974C240.46 216.974 251.282 212.343 252.949 206.351C254.615 212.343 265.437 216.974 278.552 216.974C291.667 216.974 302.489 212.343 304.155 206.351C305.821 212.343 316.643 216.974 329.758 216.974C331.386 216.974 332.984 216.905 334.528 216.768Z",
    fill: "url(#paint1_linear_1601_734)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.528 247.34V359.039H-130.336V247.546C-117.221 247.546 -106.399 242.915 -104.733 236.923C-103.067 242.915 -92.2449 247.546 -79.1299 247.546C-66.7791 247.546 -56.4614 243.442 -53.9087 237.955C-51.356 243.442 -41.0383 247.546 -28.6876 247.546C-15.5726 247.546 -4.7504 242.915 -3.08427 236.923C-1.41815 242.915 9.40402 247.546 22.519 247.546C35.634 247.546 46.4562 242.915 48.1223 236.923C49.7884 242.915 60.6106 247.546 73.7256 247.546C86.8406 247.546 97.6628 242.915 99.3289 236.923C100.995 242.915 111.817 247.546 124.932 247.546C138.047 247.546 148.869 242.915 150.535 236.923C152.202 242.915 163.024 247.546 176.139 247.546C189.254 247.546 200.076 242.915 201.742 236.923C203.408 242.915 214.23 247.546 227.345 247.546C240.46 247.546 251.282 242.915 252.949 236.923C254.615 242.915 265.437 247.546 278.552 247.546C291.667 247.546 302.489 242.915 304.155 236.923C305.821 242.915 316.643 247.546 329.758 247.546C331.386 247.546 332.984 247.478 334.528 247.34Z",
    fill: "url(#paint2_linear_1601_734)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.528 277.912V389.611H-130.336V278.119C-117.221 278.119 -106.399 273.487 -104.733 267.495C-103.067 273.487 -92.2449 278.119 -79.1299 278.119C-66.7791 278.119 -56.4614 274.014 -53.9087 268.527C-51.356 274.014 -41.0383 278.119 -28.6876 278.119C-15.5726 278.119 -4.7504 273.487 -3.08427 267.495C-1.41815 273.487 9.40402 278.119 22.519 278.119C35.634 278.119 46.4562 273.487 48.1223 267.495C49.7884 273.487 60.6106 278.119 73.7256 278.119C86.8406 278.119 97.6628 273.487 99.3289 267.495C100.995 273.487 111.817 278.119 124.932 278.119C138.047 278.119 148.869 273.487 150.535 267.495C152.202 273.487 163.024 278.119 176.139 278.119C189.254 278.119 200.076 273.487 201.742 267.495C203.408 273.487 214.23 278.119 227.345 278.119C240.46 278.119 251.282 273.487 252.949 267.495C254.615 273.487 265.437 278.119 278.552 278.119C291.667 278.119 302.489 273.487 304.155 267.495C305.821 273.487 316.643 278.119 329.758 278.119C331.386 278.119 332.984 278.05 334.528 277.912Z",
    fill: "url(#paint3_linear_1601_734)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.761 216.974C316.646 216.974 305.823 212.343 304.157 206.351C302.491 212.343 291.669 216.974 278.554 216.974C265.439 216.974 254.617 212.343 252.951 206.351C251.285 212.343 240.463 216.974 227.348 216.974C214.233 216.974 203.41 212.343 201.744 206.351C200.078 212.343 189.256 216.974 176.141 216.974C163.026 216.974 152.204 212.343 150.538 206.351C148.872 212.343 138.049 216.974 124.934 216.974C111.819 216.974 100.997 212.343 99.3311 206.351C97.665 212.343 86.8428 216.974 73.7278 216.974C60.6128 216.974 49.7906 212.343 48.1245 206.351C46.4584 212.343 35.6362 216.974 22.5212 216.974C9.40623 216.974 -1.41592 212.343 -3.08205 206.351C-4.74817 212.343 -15.5703 216.974 -28.6853 216.974C-41.0361 216.974 -51.3538 212.87 -53.9065 207.382C-56.4592 212.87 -66.7769 216.974 -79.1276 216.974C-92.2426 216.974 -103.065 212.343 -104.731 206.351C-106.397 212.343 -186.004 216.974 -199.119 216.974V247.545V278.116V328.467V359.038V389.609H410.957V359.038V328.467V277.91V247.339V216.768C409.414 216.905 331.389 216.974 329.761 216.974Z",
    fill: "url(#paint4_radial_1601_734)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.605 295.136L159.198 372.328L147.734 381.5L136.27 384.557L121.749 389.907L104.17 391.435L79.7135 392.199H5.57861V355.514L84.6966 346.083H84.7042L106.066 331.386L126.22 330.927L140.091 317.3L154.613 320.357L167.605 295.136Z",
    fill: "#A1887F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.7426 300.485L47.6139 298.192L62.1351 293.606L118.692 285.963L138.563 293.606L167.605 295.135L154.613 320.356L140.091 317.299L126.334 331.056L105.699 331.82L85.0634 346.341L5.57861 355.513L27.7426 300.485Z",
    fill: "url(#paint5_linear_1601_734)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.605 295.136L159.198 372.328L147.733 381.5L154.612 320.357L167.605 295.136Z",
    fill: "#9E76A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.614 320.358L147.735 381.5L136.271 384.557L140.092 317.301L154.614 320.358Z",
    fill: "#0A1250"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.7135 392.2H5.57861V355.515L85.0634 346.343L79.7135 392.2Z",
    fill: "#0A1250"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.092 317.301L136.271 384.557L121.75 389.907L126.335 331.058L140.092 317.301Z",
    fill: "#9E76A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.333 331.057L121.747 389.906L104.169 391.435L105.697 331.821L126.333 331.057Z",
    fill: "#0A1250"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.701 331.822L104.172 391.435L79.7153 392.2L85.0653 346.343L105.701 331.822Z",
    fill: "#9E76A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.526 142.036C150.524 142.036 150.521 142.039 150.518 142.039V142.036L143.585 142.516L144.202 151.429L151.135 150.949V150.946C151.137 150.946 151.14 150.949 151.143 150.949C151.685 150.912 151.987 148.886 151.817 146.425C151.646 143.963 151.068 141.998 150.526 142.036Z",
    fill: "#AAAAAA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.201 151.422C144.748 151.385 145.053 149.359 144.883 146.897C144.712 144.436 144.131 142.472 143.584 142.51C143.037 142.547 142.731 144.573 142.902 147.035C143.072 149.496 143.654 151.46 144.201 151.422Z",
    fill: "#CFCFCF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.374 146.939C144.253 145.183 143.972 143.76 143.721 143.547C143.68 143.505 143.654 143.505 143.654 143.505L126.577 144.688L127.057 151.62L144.134 150.438C144.134 150.438 144.159 150.434 144.194 150.387C144.413 150.144 144.496 148.695 144.374 146.939Z",
    fill: "#AAAAAA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.057 151.612C127.45 151.585 127.661 150.011 127.528 148.097C127.395 146.182 126.97 144.653 126.577 144.68C126.185 144.707 125.974 146.281 126.107 148.195C126.239 150.109 126.665 151.639 127.057 151.612Z",
    fill: "#CFCFCF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.521 145.687L111.917 146.698L112.261 151.65L126.864 150.638C127.112 150.622 127.236 149.499 127.141 148.132C127.046 146.764 126.769 145.67 126.521 145.687Z",
    fill: "#AAAAAA"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M124.434 315.504C124.434 315.504 79.2509 344.333 60.9908 346.455C58.3472 346.762 48.9542 346.719 48.3802 344.12C47.8261 341.61 55.0616 338.876 57.5516 338.239C73.2193 334.226 105.319 312.827 105.319 312.827L124.434 315.504Z",
    fill: "url(#paint6_linear_1601_734)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M91.3094 308.381C91.3094 308.381 22.1408 339.421 26.981 335.403C37.4882 326.682 73.1433 306.699 73.1433 306.699L91.3094 308.381Z",
    fill: "url(#paint7_linear_1601_734)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.272 158.521C110.687 159.866 109.201 161.242 105.75 163.284C105.75 163.284 104.369 163.965 105.06 167.368H92.634C92.634 167.368 94.602 166.204 95.8638 163.288C96.5761 161.644 96.2681 159.754 95.1775 158.325C93.7705 156.482 91.9438 153.395 91.9438 146.27C91.9438 138.104 97.9465 135.405 102.905 135.397C110.011 135.386 113.344 140.145 113.344 148.992C113.344 152.17 112.939 154.699 111.272 158.521Z",
    fill: "#DFE1E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.6188 158.658C93.3608 156.72 91.9438 154.172 91.9438 146.981C91.9438 138.738 96.6251 134.652 103.9 134.633C110 134.617 112.566 138.918 113.235 143.04C113.235 143.04 111.963 142.795 111.026 143.757C109.689 145.131 110.72 146.889 110.615 148.436C110.523 149.792 109.833 150.347 109.307 150.635C108.208 146.264 105.754 146.521 104.865 147.435C103.527 148.809 104.334 152.68 105.7 153.718C105.7 156.466 105.265 158.739 103.259 160.113C99.6714 162.569 95.9563 160.718 94.6188 158.658Z",
    fill: "#0A1250"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.316 166.033C125.034 156.465 123.227 147.751 122.911 145.92C122.875 145.716 122.717 145.556 122.512 145.515C117.975 144.863 115.369 146.146 115.369 146.146C114.613 146.573 114.558 147.806 114.64 148.661C114.886 151.235 114.108 151.444 114.108 151.444C114.108 152.584 115.184 153.034 116.109 153.718L118.038 154.642C118.038 154.642 120.758 157.321 126.197 168.711C127.006 170.408 133.456 167.532 132.316 166.033Z",
    fill: "#DFE1E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.9277 171.916L79.7145 210.296L77.3712 206.653C76.396 204.709 75.8931 202.533 75.8931 200.36V183.546C75.8931 180.727 76.5098 178.092 77.6738 175.596C78.2791 174.291 79.0327 173.06 79.9277 171.916Z",
    fill: "#AA0871"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.936 307.36V312.616C104.936 312.616 104.936 315.767 107.993 315.767C114.048 315.767 124.042 315.767 124.042 315.767C124.042 315.767 124.842 311.678 119.532 310.766C111.814 309.653 111.814 307.36 111.814 307.36H104.936Z",
    fill: "#530099"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.1182 308.262L74.9706 310.281C73.8555 310.281 72.9521 309.377 72.9521 308.262L73.6247 304.225L80.3526 302.879C81.1612 304.497 84.2375 305.438 86.0343 305.239L86.1634 305.227C88.3049 305.032 90.3196 306.267 91.1182 308.262Z",
    fill: "#530099"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.623 304.224L80.351 302.878L81.2421 297.422H74.3636L73.623 304.224Z",
    fill: "#DFE1E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.5599 221.12C80.5599 221.12 77.7213 245.597 78.5705 262.055C75.4193 272.739 72.8384 298.186 72.8384 298.186H82.0097C82.0097 298.186 92.8005 262.669 96.4675 248C97.8134 242.617 97.7859 222.842 97.7859 222.842L80.5599 221.12Z",
    fill: "#0A1250"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.171 299.479L104.935 307.357H111.814V298.715L104.171 299.479Z",
    fill: "#DFE1E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.918 224.051L113.698 299.268L104.823 299.902L102.133 300.094C102.133 300.094 99.5835 283.557 97.7859 266.043C93.0917 252.477 91.0213 235.301 88.6772 218.658L114.918 224.051Z",
    fill: "#282F6F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.916 190.118V224.05L96.2417 222.287L114.916 190.118Z",
    fill: "#D76EB2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.589 185.509L132.674 183.452C137.505 182.848 140.114 177.467 137.597 173.296L132.136 164.44L125.009 168.006L126.345 170.417C126.699 171.019 126.015 171.697 125.416 171.335L120.092 168.108C117.115 166.707 113.906 165.863 110.625 165.619L96.4721 164.568C89.9811 164.069 83.9189 166.458 79.9286 171.884C79.8308 172.017 78.5835 193.951 78.5835 207.852C78.5835 213.47 77.3155 215.837 74.2875 218.093C72.1804 219.663 71.3091 220.233 71.3091 220.233C71.3091 220.233 72.3118 222.854 77.0412 226.967C80.002 229.543 87.5706 230.122 93.7597 230.122C99.9488 230.122 105.702 233.225 105.702 233.225C105.702 233.225 113.192 213.55 114.391 203.728C115.589 193.906 115.589 185.509 115.589 185.509Z",
    fill: "#530099"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.2867 218.1C72.1804 219.669 71.3091 220.232 71.3091 220.232C71.3091 220.232 72.3118 222.859 77.0412 226.97C80.002 229.544 87.5706 230.123 93.7597 230.123C99.9488 230.123 105.702 233.224 105.702 233.224C105.702 233.224 106.418 231.69 107.334 229.076C98.823 221.652 82.2635 229.932 74.2867 218.1Z",
    fill: "#AA0871"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.008 168.038L132.135 164.475L134.251 168.202L126.344 170.448L125.008 168.038Z",
    fill: "#AA0871"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_1601_734",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(227.595 188.518) scale(92.6623 92.9798)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEEEEE",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1601_734",
    x1: 102.096,
    y1: 328.467,
    x2: 102.096,
    y2: 206.351,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5F5F5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1601_734",
    x1: 102.096,
    y1: 359.039,
    x2: 102.096,
    y2: 236.923,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6802,
    stopColor: "#F5F5F5",
    stopOpacity: 0.6802
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEEEEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1601_734",
    x1: 102.096,
    y1: 389.611,
    x2: 102.096,
    y2: 267.495,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4295,
    stopColor: "#F5F5F5",
    stopOpacity: 0.4295
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E0E0E0"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_1601_734",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(97.8923 114.716) rotate(-0.166157) scale(250.593 319.782)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0894,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8713,
    stopColor: "white",
    stopOpacity: 0.8587
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1601_734",
    x1: 5.55016,
    y1: 355.521,
    x2: 167.603,
    y2: 295.627,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0A1250"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E3C9DD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1601_734",
    x1: 86.3922,
    y1: 346.585,
    x2: 86.3922,
    y2: 312.827,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1417,
    stopColor: "#E6E2E0",
    stopOpacity: 0.1511
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9379,
    stopColor: "#5D4037"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9428,
    stopColor: "#553A32"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9545,
    stopColor: "#482F29"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9696,
    stopColor: "#402924"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E2723"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1601_734",
    x1: 59.0239,
    y1: 335.762,
    x2: 59.0239,
    y2: 306.699,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2276,
    stopColor: "#D2CDCC",
    stopOpacity: 0.2276
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E2723"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgError404Image);
export default __webpack_public_path__ + "static/media/Error404Image.8d9deb40.svg";
export { ForwardRef as ReactComponent };